import { AfterViewInit, Component, ElementRef, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ApiRequestService } from '../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../toastmessage/toastmessage.service';
import { TranslationService } from '../translation/translation.service';
import { HttpError } from '../shared/httperror';
import { UploadFileResponse } from '../banners/uploadfileresponse';
import { SiteConfiguration } from './siteconfiguration';
import { Router } from '@angular/router';
import { GetSiteConfigurationResponse } from './getsiteconfigurationresponse';
import { UpdateSiteConfigRequest } from './updatesiteconfigrequest';
import { UpdateSiteConfigResponse } from './updatesiteconfigresponse';



@Component({
    selector: 'app-basedatas',
    templateUrl: './siteconfig.component.html',
    styleUrls: ['./siteconfig.component.scss']
})
export class SiteConfigComponent implements OnInit {

    getSiteconfigurationUrl = '/websiteconfigurator/get-site-configuration';

    configuratorUrl = '';

    siteConfigurationList: SiteConfiguration[] = [];


    siteConfigurationIsUrlList: SiteConfiguration[] = [];

    siteConfigForm?: FormGroup;

    updateSiteConfigUrl = '/admin/update-siteconfig';

    @ViewChildren('fileCoverInput') fileCoverInputs!: QueryList<ElementRef<HTMLInputElement>>;
    //fileCover: File | null = null;

    uploadFileToAnExistingFolderUrl = '/admin/updatefile';

    fileBaseUrl = '';


    get items() {
        return this.siteConfigForm?.get('items') as FormArray;
    }

    constructor(
        public router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorUrl: string,
        private _toastMessageService: ToastmessageService,
        private _fb: FormBuilder,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        private _translateService: TranslationService
    ) {

        this.configuratorUrl = _configuratorUrl;

        this.fileBaseUrl = _fileManagerUrl;

        this.createSiteconfigFormArray();
    }

    ngOnInit(): void {
        this.getSiteConfiguration();
    }

    getSiteConfiguration() {
        this._apiRequestService
            .sendRequest<{}, GetSiteConfigurationResponse>(this.configuratorUrl, true, {}, true, this.getSiteconfigurationUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();
                    });
                })
            )
            .subscribe((response: GetSiteConfigurationResponse) => {
                this.siteConfigurationList = response.siteConfigurationList as SiteConfiguration[];

                this.siteConfigurationIsUrlList = response.siteConfigurationIsUrlList as SiteConfiguration[];

                this.siteConfigForm = this._fb.group({
                    items: this._fb.array(this.siteConfigurationList!.map(siteConfig => this._fb.group(siteConfig)))
                });

            });
    }



    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    createSiteconfigFormArray() {
        this.siteConfigForm = this._fb.group({
            items: this._fb.array([this.siteConfigForm])
        });
    }

    updateSiteConfig() {
        const updateSiteConfigRequest: UpdateSiteConfigRequest = {
            siteConfigList: this.items.value as SiteConfiguration[]
        }

        this._apiRequestService
            .sendRequest<UpdateSiteConfigRequest, UpdateSiteConfigResponse>(this.configuratorUrl, true, updateSiteConfigRequest, true, this.updateSiteConfigUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();

                    });
                })
            )
            .subscribe((response: UpdateSiteConfigResponse) => {
                this._toastMessageService.displayToastMessage(TOAST_STATE.success, response.responseMessage!, MAT_ICON.success);
                this.updateFiles();
                this.dismissError();
                //window.location.reload();

            });

    }

    clearSelectedCoverFile(index: number) {

        this.siteConfigurationIsUrlList[index].fileCover = null;

    }

    onChange(event: Event, siteConfig: SiteConfiguration, index: number) {
        const target = event.target as HTMLInputElement;
        if (siteConfig.configurationKey === "logo_url") {
            if (target.files![0].name.split('.').pop() === 'jpg' || 'png' || 'JPEG' || 'jpeg') {
                this.siteConfigurationIsUrlList[index].fileCover = target.files![0];
            }
        }
        else if (siteConfig.configurationKey === "privacy_policy_url") {
            if (target.files![0].name.split('.').pop() === 'pdf') {
                this.siteConfigurationIsUrlList[index].fileCover = target.files![0];
            }
        }
        else if (siteConfig.configurationKey === "patient_admisson_form_url") {
            if (target.files![0].name.split('.').pop() === 'pdf') {
                this.siteConfigurationIsUrlList[index].fileCover = target.files![0];
            }
        }
        else if (siteConfig.configurationKey === "aszf_url") {
            if (target.files![0].name.split('.').pop() === 'pdf') {
                this.siteConfigurationIsUrlList[index].fileCover = target.files![0];
            }
        }
        else {
            this.siteConfigurationIsUrlList[index].fileCover = null;
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Kérem megfelelő kiterjesztésű fájlt töltsön fel!', MAT_ICON.warning);
            this.dismissError();
        }

    }

    updateFile(file: File, folderName: string, index: number) {
        this._apiRequestService.updateFile(file, folderName, true, true, this.fileBaseUrl, this.uploadFileToAnExistingFolderUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage), MAT_ICON.error);
                        this.dismissError();


                    });
                })
            )
            .subscribe((response) => {
                const uploadFileResponse = response as UploadFileResponse;
                if (uploadFileResponse.downloadUri) {
                    this._toastMessageService.displayToastMessage(
                        TOAST_STATE.success,
                        'Sikeres fájl feltöltés ' + uploadFileResponse.fileName!,
                        MAT_ICON.success
                    );
                    this.dismissError();
                    if (index === this.siteConfigurationIsUrlList.length - 1) {
                        window.location.reload();
                    }
                }

            });
    }

    updateFiles() {
        this.siteConfigurationIsUrlList.forEach((siteConfig, index) => {
            if (siteConfig.fileCover) {
                const folderName = siteConfig.configurationValue!.split('/').pop() as string;
                this.updateFile(siteConfig.fileCover!, folderName, index);

            }

        })
    }



}
